// extracted by mini-css-extract-plugin
export var arrows = "_25-5";
export var decrementer = "_25-9";
export var disabled = "_25-3";
export var error = "_25-1";
export var hiddenText = "_25-a";
export var incrementer = "_25-8";
export var input = "_25-7";
export var inputWrapper = "_25-0";
export var leadingIcon = "_25-b";
export var readonly = "_25-2";
export var regular = "_25-6";
export var small = "_25-4";